import React, { forwardRef, useEffect, useState } from 'react';

import styles from './slider-input.module.scss';

type SliderInputProps = {
  min?: number;
  max?: number;
  step?: number;
  value?: number;
  onChange?: (value: number) => void;
};

export const SliderInput = forwardRef<HTMLInputElement, SliderInputProps>(
  ({ min = 0, max = 10, step = 1, value = 1, onChange }, ref) => {
    const [currentValue, setCurrentValue] = useState(value);

    useEffect(() => {
      setCurrentValue(value);
    }, [value]);

    const getBackgroundSize = () => {
      const backgroundSizeBase = currentValue - min;

      return {
        backgroundSize: `${(backgroundSizeBase * 100) / (max - min)}% 100%`,
      };
    };

    const handleChange = (value: number) => {
      onChange && onChange(value);
      setCurrentValue(value);
    };

    const handleIncrement = () => {
      if (currentValue >= max) {
        return;
      }
      const value = currentValue + step;
      handleChange(value);
    };

    const handleDecrement = () => {
      if (currentValue <= min) {
        return;
      }
      const value = currentValue - step;
      handleChange(value);
    };

    return (
      <div className={styles['container']}>
        <span className={styles['affix']} onClick={handleDecrement}>
          -
        </span>
        <input
          className={styles['input']}
          ref={ref}
          type="range"
          value={currentValue}
          min={min}
          max={max}
          step={step}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const value = event.target.valueAsNumber;
            handleChange(value);
          }}
          style={getBackgroundSize()}
        />
        <span className={styles['affix']} onClick={handleIncrement}>
          +
        </span>
      </div>
    );
  },
);

SliderInput.displayName = 'SliderInput';
